import React from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import FooterSection from '../components/Footer';
import ContactIcon from '../components/ContactIcon';
import Aboutus from '../components/Aboutus';
import './css/pagehero.css';
import lined from '../components/images/hero/lined.png';
import { useLanguage } from '../contexts/LanguageContext';

const AboutPage = () => {
  const { t } = useLanguage();
  return (
    <>
      <Navbar />
      <section className="page-hero-section">
        <img src={lined} alt="background" className="page-hero-lined" />
        <div className="page-hero-overlay"></div>
        <div className="container">
          <motion.div 
            className="page-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>{t('pages.about')}</h1>
            <nav className="page-hero-breadcrumb">
              <a href="/">{t('pages.home')}</a>
              <span>/</span>
              <span>{t('pages.about')}</span>
            </nav>
          </motion.div>
        </div>
      </section>
      <Aboutus />
      <FooterSection />
      <ContactIcon />
    </>
  );
};

export default AboutPage;

